import { HeaderToolsComponent } from './tools/header-tools.component';
import { PrimarySearchComponent } from '@ponder-features/search/primary-search.component';
import { FilterBarComponent } from './filter-bar/filter-bar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { NgClass } from '@angular/common';
import { Subscription } from 'rxjs';
import { EventBroker } from '@ponder-core/events/eventBroker';
import { GlobalNotificationsComponent } from './notifications/global-notifications.component';
import { isMobileScreen } from '@ponder-shared/utils/screenBreakpoints';
import { Component } from '@angular/core';

@Component({
    selector: 'header',
    imports: [PrimarySearchComponent, HeaderToolsComponent, FilterBarComponent, NavbarComponent, NgClass, GlobalNotificationsComponent],
    templateUrl: './header.component.html'
})
export class HeaderComponent {
    public showNavbar: boolean = true;
    public isMobileScreen: boolean = false;
    private hideNavbarSub!: Subscription;
    private showNavbarSub!: Subscription;

    constructor(private events: EventBroker) {
        this.hideNavbarSub = this.events.ui.hideNavbarEvent.subscribe(() => { this.showNavbar = false; });
        this.showNavbarSub = this.events.ui.showNavbarEvent.subscribe(() => { this.showNavbar = true; });
    }

    public ngOnDestroy(): void {
        this.hideNavbarSub.unsubscribe();
        this.showNavbarSub.unsubscribe();
    }

    public ngOnInit(): void {
        this.isMobileScreen = isMobileScreen();
    }
}
